var _circle, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup501(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FEDC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7282 38.8552C45.7282 41.9686 44.0317 44.8269 41.2101 46.9245C38.3886 49.022 34.4672 50.3344 30.1141 50.3344C25.761 50.3344 21.8396 49.022 19.018 46.9245C16.1964 44.8269 14.5 41.9686 14.5 38.8552C14.5 37.2887 14.9448 36.6229 15.5537 36.3197C16.2462 35.9749 17.3257 35.9917 18.8415 36.2527C19.7054 36.4015 20.6409 36.614 21.6606 36.8458C22.4217 37.0187 23.2299 37.2024 24.0903 37.3781C26.0711 37.7827 28.2539 38.1267 30.5273 38.1267C33.8148 38.1267 36.8616 37.3964 39.3233 36.8063C40.2374 36.5872 41.0708 36.3875 41.8059 36.2516C42.4958 36.1241 43.0927 36.0523 43.6002 36.059C44.1081 36.0658 44.4948 36.1511 44.7862 36.3107C45.3198 36.6029 45.7282 37.2644 45.7282 38.8552Z",
    fill: "#B4643A",
    stroke: "#B4643A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.171 39.8714C46.2088 39.5364 46.2282 39.1975 46.2282 38.8552C46.2282 34.6355 43.4614 35.2987 39.1481 36.3328C36.6987 36.9199 33.7506 37.6267 30.5273 37.6267C27.3598 37.6267 24.3534 36.9442 21.7947 36.3634C17.1643 35.3123 14 34.594 14 38.8552C14 39.178 14.0172 39.4979 14.0509 39.8143C15.4676 39.9506 17.1037 40.2261 18.9043 40.5294C22.353 41.1102 26.4051 41.7927 30.6743 41.7927C35.0188 41.7927 38.9923 41.0859 42.2937 40.4988C43.7196 40.2451 45.0201 40.0138 46.171 39.8714Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7282 38.8552C45.7282 41.9686 44.0317 44.8269 41.2101 46.9245C38.3886 49.022 34.4672 50.3344 30.1141 50.3344C25.761 50.3344 21.8396 49.022 19.018 46.9245C16.1964 44.8269 14.5 41.9686 14.5 38.8552C14.5 37.2887 14.9448 36.6229 15.5537 36.3197C16.2462 35.9749 17.3257 35.9917 18.8415 36.2527C19.7054 36.4015 20.6409 36.614 21.6606 36.8458C22.4217 37.0187 23.2299 37.2024 24.0903 37.3781C26.0711 37.7827 28.2539 38.1267 30.5273 38.1267C33.8148 38.1267 36.8616 37.3964 39.3233 36.8063C40.2374 36.5872 41.0708 36.3875 41.8059 36.2516C42.4958 36.1241 43.0927 36.0523 43.6002 36.059C44.1081 36.0658 44.4948 36.1511 44.7862 36.3107C45.3198 36.6029 45.7282 37.2644 45.7282 38.8552Z",
    stroke: "#B4643A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6783,
    cy: 24.8659,
    rx: 3.81894,
    ry: 4.58273,
    fill: "#B4643A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.8189,
    cy: 24.8659,
    rx: 3.81894,
    ry: 4.58273,
    fill: "#B4643A"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.3592,
    cy: 32.5712,
    rx: 4.35918,
    ry: 2.17959,
    fill: "#FF9C8E"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.1404,
    cy: 32.5712,
    rx: 4.35918,
    ry: 2.17959,
    fill: "#FF9C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup501);
export default __webpack_public_path__ + "static/media/Group 501.c7d3f258b16ff143ef3f75bb18703429.svg";
export { ForwardRef as ReactComponent };